import React from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';

const ResetPasswordForm = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  loading,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  errors,
  handleSubmit,
  isMobile = false
}) => {
  return (
    <form onSubmit={handleSubmit} className={isMobile ? "space-y-6" : "space-y-8"}>
      <div className={isMobile ? "space-y-2" : "space-y-3"}>
        <label className="flex items-center space-x-2 text-slate-700 font-bold text-sm">
          <Lock className="h-4 w-4" />
          <span>New Password</span>
        </label>
        <div className="relative">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter your new password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`w-full ${isMobile ? 'h-14 px-4 pr-12 text-base' : 'h-16 px-6 pr-16 text-lg'} bg-slate-50 border-2 rounded-2xl focus:ring-4 focus:ring-teal-100 focus:outline-none transition-all duration-300 text-slate-800 placeholder-slate-400 hover:border-slate-300 ${errors.password ? 'border-red-500 focus:border-red-500' : 'border-slate-200 focus:border-teal-500'}`}
            disabled={loading}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className={`absolute ${isMobile ? 'right-3' : 'right-5'} top-1/2 -translate-y-1/2 text-slate-400 hover:text-teal-600 transition-colors p-2`}
            disabled={loading}
          >
            {showPassword ? <EyeOff className={isMobile ? "h-5 w-5" : "h-6 w-6"} /> : <Eye className={isMobile ? "h-5 w-5" : "h-6 w-6"} />}
          </button>
        </div>
        {errors.password && (
          <p className="text-red-500 text-sm mt-1">{errors.password}</p>
        )}
      </div>

      <div className={isMobile ? "space-y-2" : "space-y-3"}>
        <label className="flex items-center space-x-2 text-slate-700 font-bold text-sm">
          <Lock className="h-4 w-4" />
          <span>Confirm Password</span>
        </label>
        <div className="relative">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder="Re-enter your password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={`w-full ${isMobile ? 'h-14 px-4 pr-12 text-base' : 'h-16 px-6 pr-16 text-lg'} bg-slate-50 border-2 rounded-2xl focus:ring-4 focus:ring-teal-100 focus:outline-none transition-all duration-300 text-slate-800 placeholder-slate-400 hover:border-slate-300 ${errors.confirmPassword ? 'border-red-500 focus:border-red-500' : 'border-slate-200 focus:border-teal-500'}`}
            disabled={loading}
            required
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className={`absolute ${isMobile ? 'right-3' : 'right-5'} top-1/2 -translate-y-1/2 text-slate-400 hover:text-teal-600 transition-colors p-2`}
            disabled={loading}
          >
            {showConfirmPassword ? <EyeOff className={isMobile ? "h-5 w-5" : "h-6 w-6"} /> : <Eye className={isMobile ? "h-5 w-5" : "h-6 w-6"} />}
          </button>
        </div>
        {errors.confirmPassword && (
          <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>
        )}
      </div>

      <button
        type="submit"
        className={`w-full ${isMobile ? 'h-14 font-bold text-lg rounded-xl' : 'h-16 font-bold text-xl rounded-2xl'} bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-500 hover:from-teal-700 hover:via-teal-600 hover:to-cyan-600 text-white shadow-2xl hover:shadow-teal-500/25 transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none`}
        disabled={loading}
      >
        {loading ? (
          <div className="flex items-center justify-center space-x-3">
            <div className={`w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin`}></div>
            <span>Resetting Password...</span>
          </div>
        ) : (
          'Reset Password'
        )}
      </button>
    </form>
  );
};

export default ResetPasswordForm;
